<template>
  <div class="container1400">
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12" md="4" sm="4" class="d-none d-sm-inline-flex">
          <router-link class="navbar-brand" to="/">
            <v-img
              src="../../assets/images/logo.png"
              alt="Nomad Rooms"
              class="shrink mr-2"
              contain
              transition="scale-transition"
              width="240"
            />
          </router-link>
        </v-col>
        <v-col cols="12" sm="8" md="8">
          <div class="float-left d-sm-none d-inline-flex">
            <router-link class="navbar-brand" to="/">
              <v-img
                src="../../assets/images/logo-icon.png"
                alt="Nomad Rooms"
                class="shrink mr-2"
                contain
                transition="scale-transition"
                width="36"
              />
            </router-link>
          </div>
          <div class="float-right">
            <CurrencySelectorComponent />
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" color="light-blue">
                  <v-icon>mdi-web</v-icon>{{ $i18n.locale }}
                </v-btn>
              </template>
              <v-list v-model="$i18n.locale">
                <v-list-item v-for="(item, i) in items" :key="i">
                  <v-list-item-title>
                    <v-btn text @click="changeLocale(item.code)">
                      {{ item.title }}
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <TawkChatComponent />
            <v-menu offset-y left z-index="5000">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  rounded
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  color="light-blue"
                >
                  <v-icon color="grey" small>mdi-menu</v-icon>
                  <v-icon
                    v-if="!$store.state.user.profilePic"
                    color="light-blue"
                    class="ml-2"
                    >mdi-account-circle</v-icon
                  >
                  <v-avatar
                    class="ml-2"
                    v-if="$store.state.user.profilePic"
                    size="25"
                  >
                    <img
                      :src="$store.state.baseUrl + $store.state.user.profilePic"
                      alt="Dashboard"
                    />
                  </v-avatar>
                </v-btn>
              </template>
              <v-list dense min-width="200px">
                <v-list-item
                  href="https://member.nomadrooms.com/"
                  target="_blank"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-open-in-new</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ $t("About") }} Nomad</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="$store.getters.isLoggedIn"
                  to="/dashboard"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-view-dashboard</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Dashboard") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  to="/listing/add"
                  v-if="$store.getters.isLoggedIn"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-home-city-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span v-if="$store.state.user.role === 'Host'">{{
                        $t("AddNewProperty")
                      }}</span>
                      <span v-else>{{ $t("BecomeaPartner") }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="!$store.getters.isLoggedIn"
                  to="/register?redirect=/listing/add"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-home-city-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span v-if="$store.state.user.role === 'Host'">{{
                        $t("AddNewProperty")
                      }}</span>
                      <span v-else>{{ $t("BecomeaPartner") }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="!$store.getters.isLoggedIn"
                  to="/register"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-account-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("BecomeNomad")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="!$store.getters.isLoggedIn"
                  to="/login"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-login</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Login") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="$store.getters.isLoggedIn" @click="logout">
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("LogOut") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { loadLanguageAsync } from "@/plugins/i18n";
import CurrencySelectorComponent from "@/components/layout/CurrencySelectorComponent.vue";
import TawkChatComponent from "@/components/layout/TawkChatComponent.vue";

export default {
  name: "FullHeaderComponent",
  components: { CurrencySelectorComponent, TawkChatComponent },
  data() {
    return {
      dialog: false,
      prefered_currency: this.$store.state.user.prefered_currency,
      items: [
        { title: "English", code: "en", alpha: "us" },
        { title: "Japanese", code: "ja", alpha: "jp" }
      ]
    };
  },
  methods: {
    changeLocale(val) {
      loadLanguageAsync(val);
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "Login" });
      });
    }
  }
};
</script>

<style scoped>
.unread {
  font-weight: bold;
  background: #f1f1f1;
}
</style>
